var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/tabber_offer_selected.02ac230b.png","uri@2x": __webpack_public_path__ + "static/media/tabber_offer_selected.35d3f52c.png","uri@3x": __webpack_public_path__ + "static/media/tabber_offer_selected.7e773dc5.png",
    width: 24,
    height: 24
});